export default __webpack_public_path__ + "static/media/closeIcon.5cc9a628.svg";